module.exports = __webpack_public_path__ + "assets/img/muji_1.4ca300f7.jpg";